#import "../../../../common/graphql/SecureRowLevelsEntityFields.graphql"
query TravelerCommonData {
  travelerAvailableDocumentTypes {
    nodes {
      id
      documentType
    }
  }
  dietaryRequirements(orderBy: [SORT_ORDER_ASC, ID_ASC]) {
    nodes {
      id
      isDescriptionRequired
      description
    }
  }
  travelPolicies(orderBy: [SORT_ORDER_ASC, DESCRIPTION_ASC]) {
    nodes {
      id
      description
      isContractual
      isCompanion
      isEconomyClassAllowed
      isBusinessClassAllowed
      isFirstClassAllowed
      isPremiumClassAllowed
      isCharterClassAllowed
      companionTickets
      companionAmount
      isDefaultCustomizable
      companyCurrency {
        isoCode
      }
      travelPolicyAllowancesByTravelPolicyId(orderBy: SORT_ORDER_ASC) {
        nodes {
          id
          expenditureType {
            expenditureType
          }
          _allowanceDescription
          isAllowanceCustomizable
          policyAllowance
          policyMaxLimit
        }
      }
    }
  }
  countries(orderBy: COUNTRY_ASC) {
    nodes {
      id
      country
    }
  }
  companyDepartments(
    orderBy: [NAME_ASC, PRIMARY_KEY_ASC]
    filter: { _isSystemInternal: { notEqualTo: true } }
  ) {
    nodes {
      id
      name
    }
  }
  userOccupationTitles(orderBy: USER_OCCUPATION_TITLE_ASC) {
    nodes {
      id
      userOccupationTitle
    }
  }
  secureRowLevels(orderBy: SECURITY_LEVEL_ASC) {
    nodes {
      ...SecureRowLevelsEntityFields
    }
  }
  travelerCompanionMasters(
    orderBy: [COMPANY_OR_LAST_NAME_ASC, FIRST_NAME_ASC]
  ) {
    nodes {
      id
      _fullName
      travelerDepartmentId
      isEconomyClassPreferred
      isBusinessClassPreferred
      isFirstClassPreferred
      isPremiumClassPreferred
      isCharterClassPreferred
    }
  }
}
